import { render, staticRenderFns } from "./employees-add-or-update.vue?vue&type=template&id=4a90032d&"
import script from "./employees-add-or-update.vue?vue&type=script&lang=js&"
export * from "./employees-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports